// @flow
/**
 * DEPRECATED
 * This component was built originally for uncontrolled forms but now we are moving towards
 * controlled forms because they are a more common React pattern. For more info check the link.
 * Alternative:
 * Use components in bench-internal-theme/form-input-fields. If this component doesn't exist, make a
 * copy and refactor so it can be used in a controlled form.
 * @link https://benchco.atlassian.net/browse/IN-2122?utm_medium=referral-external&utm_source=jira-slack&utm_term=
 */
import React, { Component } from 'react';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';
import {
  formatDollarsForDisplay,
  formatCentsAsDollars,
  parseDollarsToCents,
} from 'bench-internal-theme';

import TextInput from './TextInput';

const styleTypeColors = {
  credit: colors.copper,
  debit: colors.bonsai,
};

const CurrencyDisplayInput = styled(TextInput)`
  ${({ styleType }) =>
    styleTypeColors[styleType] &&
    `
    color: ${styleTypeColors[styleType]};
      ::placeholder {
        color: ${styleTypeColors[styleType]};
      }
  `};
  text-align: right;
`;

type CurrencyInputProps = {
  defaultAmountInCents?: number,
  name?: string,
  onBlur?: (event: any) => void,
  onChange?: (event: any) => void,
  onFocus?: (event: any) => void,
  styleType?: 'debit' | 'credit',
};

type CurrencyInputState = {
  amountInDollars: string,
  isFocused: boolean,
};

class CurrencyInput extends Component<CurrencyInputProps, CurrencyInputState> {
  static defaultProps = {
    defaultAmountInCents: undefined,
    name: undefined,
    onBlur: undefined,
    onChange: undefined,
    onFocus: undefined,
    styleType: undefined,
  };

  constructor(props: CurrencyInputProps) {
    super(props);

    this.state = {
      isFocused: false,
      amountInDollars: props.defaultAmountInCents
        ? formatCentsAsDollars(props.defaultAmountInCents)
        : '',
    };
  }

  handleFocus = (focusEvent: any) => {
    const inputElement = focusEvent.target;
    this.setState({ isFocused: true }, () => {
      inputElement.select();
    });

    if (typeof this.props.onFocus === 'function') {
      this.props.onFocus(focusEvent);
    }
  };

  handleBlur = (blurEvent: any) => {
    this.setState({
      isFocused: false,
    });

    if (typeof this.props.onBlur === 'function') {
      this.props.onBlur(blurEvent);
    }
  };

  handleChange = (changeEvent: any) => {
    const inputValue = changeEvent.target.value;
    this.setState({ amountInDollars: inputValue });

    if (typeof this.props.onChange === 'function') {
      this.props.onChange(changeEvent);
    }
  };

  render() {
    const { name, styleType, onChange, onFocus, onBlur, ...props } = this.props;
    const { amountInDollars, isFocused } = this.state;

    let amountInCents = parseDollarsToCents(amountInDollars);
    if (Number.isNaN(amountInCents)) {
      amountInCents = '';
    }

    return (
      <div>
        <CurrencyDisplayInput
          data-test-id="currency-input-display-amount"
          placeholder="-"
          styleType={styleType}
          step=".01"
          {...props}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          type={isFocused ? 'number' : 'text'}
          value={isFocused ? amountInDollars : formatDollarsForDisplay(amountInDollars)}
        />
        <input
          value={amountInCents}
          data-test-id="currency-input-amount"
          name={name}
          type="hidden"
        />
      </div>
    );
  }
}

export default CurrencyInput;
